import { render, staticRenderFns } from "./HeatmapColorBar.vue?vue&type=template&id=36ea96de&scoped=true&"
import script from "./HeatmapColorBar.vue?vue&type=script&lang=ts&"
export * from "./HeatmapColorBar.vue?vue&type=script&lang=ts&"
import style0 from "./HeatmapColorBar.vue?vue&type=style&index=0&id=36ea96de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea96de",
  null
  
)

export default component.exports